import { render } from "./MarketsPage.vue?vue&type=template&id=eefc1ad8"
import script from "./MarketsPage.vue?vue&type=script&lang=js"
export * from "./MarketsPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MarketsPage.vue?vue&type=style&index=0&id=eefc1ad8&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__